import React from 'react';
import {Alert, Spinner} from "react-bootstrap";

function LoadingSpinner() {
    return (
        <div className="text-center">
            <Spinner/>
        </div>

    );
}

export default LoadingSpinner;


export function ErrorAlert(props) {

    return (
        <>
            <Alert variant="danger">
                <Alert.Heading>{props.message}</Alert.Heading>
                <hr/>
                <div className="row">
                    <p className="col-9 mb-0">
                        رفرش
                    </p>
                    <button className="col-3">refresh</button>
                </div>

            </Alert>
        </>
    );
}

